import React from 'react';
import PropTypes from 'prop-types';

function PsButton({ active, activeColor, background, color }) {
  return (
    <>
      <path
        d="M416.137 309.533C416.137 319.859 407.766 328.231 397.439 328.231C387.112 328.231 378.741 319.859 378.741 309.533C378.741 299.206 387.112 290.835 397.439 290.835C407.766 290.835 416.137 299.206 416.137 309.533Z"
        fill={active ? activeColor : background}
      />
      <path
        d="M408.804 314.777C408.375 315.351 407.322 315.761 407.322 315.761L399.489 318.744V316.544L405.253 314.367C405.908 314.119 406.008 313.767 405.476 313.583C404.946 313.398 403.985 313.451 403.33 313.701L399.489 315.135V312.852L399.711 312.773C399.711 312.773 400.821 312.356 402.381 312.173C403.942 311.991 405.853 312.198 407.353 312.801C409.043 313.367 409.234 314.202 408.804 314.777ZM400.235 311.031V305.407C400.235 304.746 400.12 304.138 399.535 303.966C399.088 303.814 398.81 304.255 398.81 304.915V319L395.226 317.794V301C396.75 301.3 398.97 302.009 400.163 302.435C403.198 303.539 404.227 304.914 404.227 308.011C404.227 311.03 402.469 312.175 400.235 311.031ZM388.651 316.314C386.916 315.796 386.627 314.717 387.418 314.095C388.149 313.521 389.392 313.088 389.392 313.088L394.53 311.152V313.36L390.833 314.762C390.18 315.011 390.079 315.362 390.61 315.547C391.141 315.731 392.103 315.679 392.757 315.43L394.53 314.747V316.723C394.418 316.744 394.292 316.765 394.177 316.786C392.403 317.093 390.513 316.965 388.651 316.314Z"
        fill={color}
      />
    </>
  );
}

PsButton.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
};

PsButton.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  background: '#030303',
  color: '#F5F5F5',
};

export default PsButton;
